import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { CommentBoxModule } from '@portal-core/tasks/components/comment-box/comment-box.module';
import { TaskAssetIconModule } from '@portal-core/tasks/components/task-asset-icon/task-asset-icon.module';
import { TaskAssetModule } from '@portal-core/tasks/components/task-asset/task-asset.module';
import { TaskCommentGroupModule } from '@portal-core/tasks/components/task-comment-group/task-comment-group.module';
import { TaskCommentIconModule } from '@portal-core/tasks/components/task-comment-icon/task-comment-icon.module';
import { TaskProfileDialogComponent } from '@portal-core/tasks/components/task-profile-dialog/task-profile-dialog.component';
import { RichTextBlockModule } from '@portal-core/text-editor/components/rich-text-block/rich-text-block.module';
import { RichTextEditorModule } from '@portal-core/text-editor/components/rich-text-editor/rich-text-editor.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { GridModule } from '@portal-core/ui/grid/grid.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { TaskProfileDialogAttachmentsComponent } from './task-profile-dialog-attachments/task-profile-dialog-attachments.component';
import { TaskProfileDialogDetailsComponent } from './task-profile-dialog-details/task-profile-dialog-details.component';
import { TaskProfileDialogDiscussionComponent } from './task-profile-dialog-discussion/task-profile-dialog-discussion.component';
;

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    MatDividerModule,
    MatFormFieldModule,
    MatTabsModule,
    MatDatepickerModule,
    MatIconModule,
    DropdownArrowModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatSnackBarModule,
    PluralizeModule,
    MatToolbarModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTooltipModule,
    GridModule,
    LoaderModule,
    ProjectAvatarModule,
    LicenseUserAvatarModule,
    TaskCommentGroupModule,
    TaskAssetModule,
    CommentBoxModule,
    ConfirmDialogModule,
    MatProgressBarModule,
    TaskAssetIconModule,
    TaskCommentIconModule,
    RichTextBlockModule,
    RichTextEditorModule,
    LicenseUserForLicenseAsyncModule
  ],
  declarations: [
    TaskProfileDialogComponent,
    TaskProfileDialogDetailsComponent,
    TaskProfileDialogDiscussionComponent,
    TaskProfileDialogAttachmentsComponent
  ],
  exports: [TaskProfileDialogComponent]
})
export class TaskProfileDialogModule { }
